import { MAX_DISPLAYED_DMS_ON_LB_CARD } from '../../../../shared/types';
import type { DmsWithLegislativeBodies, NormalizedDMsAndLBs } from '../../types';

export const normalizeDmsAndLBs = (dmsAndLBs: DmsWithLegislativeBodies | undefined): NormalizedDMsAndLBs => {
	if (!dmsAndLBs) return [];

	return dmsAndLBs.map((item) => {
		const normalizeDMs = item.decisionMakers.map((dm) => normalizeDM(dm, item.location));
		const viewMoreCount = Math.max(0, item.decisionMakers.length - MAX_DISPLAYED_DMS_ON_LB_CARD);
		const responseCount = item.decisionMakers.filter((dm) => dm.recentResponse).length;

		if (item.decisionMakers.length === 1) {
			return {
				type: 'single',
				displayedDMs: normalizeDMs,
			};
		}
		return {
			type: 'legislative_body',
			title: item.bodyTitle || '',
			location: item.location,
			displayedDMs: normalizeDMs.slice(0, MAX_DISPLAYED_DMS_ON_LB_CARD),
			allDMs: normalizeDMs,
			responseCount,
			viewMoreCount,
		};
	});
};

export const normalizeDM = (
	dm: DmsWithLegislativeBodies[number]['decisionMakers'][number],
	location: string | null,
) => {
	const constituentCountLocalized = dm.constituentCountAmongSignersLocalized ?? '0';

	return {
		id: dm.id,
		displayName: dm.displayName,
		slug: dm.slug,
		title: dm.title,
		publiclyVisible: dm.publiclyVisible,
		type: dm.type,
		location,
		photoUrl: dm.photo?.userMedium.processing ? null : (dm.photo?.userMedium.url ?? null),
		response: dm.recentResponse,
		constituentCountLocalized,
		constituentCount: parseInt(constituentCountLocalized.replace(/,/g, ''), 10) || 0,
		isFormer: dm.title?.startsWith('Former') || false,
		titleStrippedDown: null,
		isAutoAdded: false,
	};
};
